module.exports = __webpack_public_path__ + "img/box-memo.13c26942.svg";